import { useHandler } from "@redotech/react-util/hook";
import type { SplitSupportTicketAction as SplitSupportTicketActionType } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SplitSupportTicketAction = memo(function SplitSupportTicketAction({
  action,
  onChange,
  editableFields,
}: {
  action: SplitSupportTicketActionType;
  onChange: (updated: SplitSupportTicketActionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const { t } = useTranslation();
  const routeEditable =
    editableFields === undefined ||
    editableFields.has("routeFutureMessagesToNewTicket");

  const handleRouteChange = useHandler((value: boolean) => {
    if (!routeEditable) {
      return;
    }
    onChange({ ...action, routeFutureMessagesToNewTicket: value });
  });

  return (
    <Flex dir="column" gap="xs" w="full">
      <Text fontSize="sm" fontWeight="medium">
        {t("Future messages")}
      </Text>
      <RedoToggle
        description={t(
          "When off, future messages stay on the original ticket.",
        )}
        disabled={!routeEditable}
        label={t("Route future messages to the new ticket")}
        setValue={handleRouteChange}
        size="xs"
        value={action.routeFutureMessagesToNewTicket}
      />
    </Flex>
  );
});
